import React from 'react';
import PropTypes from 'prop-types';
import { Link as MuiLink, Box } from '@mui/material';

const Link = ({ children, onClick }) => (
  <Box textAlign="center">
    <MuiLink variant="body1" onClick={onClick}>
      {children}
    </MuiLink>
  </Box>
);

Link.propTypes = {
  children: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default Link;
